import { Model } from 'vuex-orm';

export default class Policy extends Model {
  static entity = 'policies';

  static fields() {
    return {
      id: this.attr(null),
      company_id: this.attr(null),
      text: this.attr(''),
      created_at: this.attr(''),
      updated_at: this.attr(''),
    };
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/policy/model.js